import { Theme } from "@emotion/react";
import { KonturColors } from "@skbkontur/colors";

import { buildTheme } from "./ThemeBuilder/BuildTheme";
import { IThemeTokens } from "./ThemeBuilder/ThemeTokens";

export const defaultThemeTokens: IThemeTokens = {
    colors: {
        blackAndWhite: {
            primaryBackgroundColor: KonturColors.grayscaleWhiteFFF,
            panelBackgroundColor: KonturColors.grayscaleLightBackground,
            panelSecondaryColor: KonturColors.grayscaleSecondaryText,
            panelBackgroundColorAsBlackTransparent: KonturColors.grayscale6LightBackground,
            panel2BackgroundColor: KonturColors.grayscaleBackground,
            panel2BackgroundColorAsBlackTransparent: KonturColors.grayscale10Background,
            panel3BackgroundColor: KonturColors.grayscaleLightBackground,
            dividerColor: KonturColors.grayscale10Background,
            inactiveTextColor: KonturColors.grayscale32DisabledText,
            secondaryTextColor: KonturColors.grayscaleSecondaryText,
            primaryTextColor: KonturColors.grayscaleText,
            invertedColors: {
                backgroundColor: KonturColors.grayscaleBlack000,
                hoveredColor: KonturColors.grayscaleText,
                color: KonturColors.grayscaleWhiteFFF,
                inactiveColor: KonturColors.grayscaleSecondaryText,
            },
        },
        brand: {
            primaryColor: KonturColors.grayscaleText,
            panelColor: KonturColors.orange80,
        },
        semantic: {
            action: {
                backgroundColor: KonturColors.blue10,
                alternativeColor: KonturColors.primaryDefault,
                iconColor: KonturColors.blue90,
                color: KonturColors.mainLinkTextBlue90,
            },
            danger: {
                backgroundColor: KonturColors.mainErrorBackgroundRed10,
                alternativeColor: KonturColors.red80,
                iconColor: KonturColors.red70,
                color: KonturColors.red100,
            },
            warning: {
                backgroundColor: KonturColors.mainWarningBackgroundYellow10,
                alternativeColor: KonturColors.mainWarningShapeYellow50,
                iconColor: KonturColors.mainWarningShapeYellow50,
                color: KonturColors.mainWarningTextYellow80,
            },
            success: {
                backgroundColor: KonturColors.mainSuccessBackgroundGreen10,
                alternativeColor: KonturColors.green100,
                iconColor: KonturColors.green70,
                color: KonturColors.green100,
            },
        },
    },
    type: {},
    spacing: {},
};

export const defaultCandyTheme: Theme = {
    candy: buildTheme(defaultThemeTokens),
};
